/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useLocation, useParams } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import { FaSort } from "react-icons/fa";
import { useRecomendacao } from "../../context/useRecomendacao";
import { useHistory } from "react-router-dom";
import { Ordenacao } from "../Ordenacao";
import { SearchInput } from "../SearchInput";
import { usePersonalizacao } from "../../context/usePersonalizacao";
import debounce from "lodash.debounce";

export function Header() {
  const location = useLocation();
  const history = useHistory();
  const { nomerecomendacao } = useParams();
  const {
    selectedFiltros,
    limpaFiltros,
    setInputSearch,
    destaquesLabel,
    ofertasLabel,
    cashbackLabel,
    descontoExclusivoLabel,
  } = useRecomendacao();
  const {
    personalizacao: { headernavigation },
  } = usePersonalizacao();

  const [ordenacaoModalOpen, setOrdenacaoModalOpen] = useState(false);

  function verMaisTitle() {
    if (nomerecomendacao === "destaques") {
      return destaquesLabel;
    }
    if (nomerecomendacao === "tabloide") {
      return ofertasLabel;
    }
    if (nomerecomendacao === "descontoexclusivo") {
      return descontoExclusivoLabel;
    }
    if (nomerecomendacao === "cashback") {
      return cashbackLabel;
    }
  }

  useEffect(() => {
    return () => debouncedResults.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  function handleChange(e){
    setInputSearch(e.target.value)
  }

  const debouncedResults = useMemo(() => {
    return debounce(handleChange, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  if (location.pathname === "/filtros") {
    return (
      <Box height="4rem" background="#fff">
        <Box
          maxWidth="900px"
          height="4rem"
          margin="0 auto"
          padding="0.5rem"
          display="flex"
          alignItems="center"
          justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Box cursor="pointer">
              <FiChevronLeft
                size={24}
                color={headernavigation.colorbotaoleftright}
                onClick={() => history.goBack()}
              />
            </Box>
            <Text
              marginLeft="1.6rem"
              fontSize="1rem"
              fontWeight="bold"
              color={headernavigation.colortextfiltro}>
              Filtros
            </Text>
          </Box>
          <Text
            onClick={limpaFiltros}
            cursor="pointer"
            fontSize="x-small"
            color={headernavigation.colorbotaoleftright}
            fontWeight="bold">
            Limpar {`(${selectedFiltros.length})`}
          </Text>
        </Box>
      </Box>
    );
  }
  if (location.pathname.split("/")[1] === "vermais") {
    return (
      <>
        <Box height="4rem" background="#fff">
          <Box
            maxWidth="900px"
            height="4rem"
            margin="0 auto"
            padding="0.5rem"
            display="flex"
            alignItems="center"
            justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <Box cursor="pointer">
                <FiChevronLeft
                  size={24}
                  color={headernavigation.colorbotaoleftright}
                  onClick={() => history.goBack()}
                />
              </Box>
              <Text
                marginLeft="1.6rem"
                fontSize="1rem"
                fontWeight="bold"
                color={headernavigation.colortextfiltro}>
                {verMaisTitle()}
              </Text>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              onClick={() => setOrdenacaoModalOpen(true)}>
              <FaSort size={16} color={headernavigation.colorbotaoleftright} />
              <Text
                cursor="pointer"
                fontSize="x-small"
                color={headernavigation.colorbotaoleftright}
                fontWeight="bold">
                Ordenar
              </Text>
            </Box>
          </Box>
        </Box>
        <Ordenacao
          isOpen={ordenacaoModalOpen}
          onRequestClose={() => setOrdenacaoModalOpen(false)}
        />
      </>
    );
  }
  if (location.pathname === "/pesquisa") {
    return (
      <>
        <Box height="4rem" background="#fff">
          <Box
            maxWidth="900px"
            height="4rem"
            margin="0 auto"
            padding="0.25rem"
            display="flex"
            alignItems="center"
            justifyContent="flex-start">
            <Box display="flex" alignItems="center" marginRight="1rem">
              <Box cursor="pointer">
                <FiChevronLeft
                  size={24}
                  color={headernavigation.colorbotaoleftright}
                  onClick={() => history.goBack()}
                />
              </Box>
            </Box>
            <SearchInput
              placeholder="Pesquisar oferta"
              _placeholder={[{ color: "#70747D" }]}
              onChange={debouncedResults}
              autoFocus={true}
            />
          </Box>
        </Box>
      </>
    );
  }

  if (location.pathname.split("/")[1] === "descricao") {
    return (
      <>
        <Box height="4rem" background="#fff">
          <Box
            maxWidth="900px"
            height="4rem"
            margin="0 auto"
            padding="0.5rem"
            display="flex"
            alignItems="center"
            justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <Box cursor="pointer">
                <FiChevronLeft
                  size={24}
                  color={headernavigation.colorbotaoleftright}
                  onClick={() => history.goBack()}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    );
  }
}
